// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/flow.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { BranchTrigger, FieldError, ListSort, Ownership, Pagination, PaginationMeta, TagRef } from "./common_pb.js";
import { Condition } from "./rule_pb.js";

/**
 * FlowLanderRole labels a LANDER node's funnel position for step labeling and
 * the campaign funnel report. Descriptive only — the router never branches on
 * it. Unspecified is treated as LANDING.
 *
 * @generated from enum tracker.v1.FlowLanderRole
 */
export enum FlowLanderRole {
  /**
   * @generated from enum value: FLOW_LANDER_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FLOW_LANDER_ROLE_PRELANDER = 1;
   */
  PRELANDER = 1,

  /**
   * @generated from enum value: FLOW_LANDER_ROLE_LANDING = 2;
   */
  LANDING = 2,

  /**
   * @generated from enum value: FLOW_LANDER_ROLE_THANKYOU = 3;
   */
  THANKYOU = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(FlowLanderRole)
proto3.util.setEnumType(FlowLanderRole, "tracker.v1.FlowLanderRole", [
  { no: 0, name: "FLOW_LANDER_ROLE_UNSPECIFIED" },
  { no: 1, name: "FLOW_LANDER_ROLE_PRELANDER" },
  { no: 2, name: "FLOW_LANDER_ROLE_LANDING" },
  { no: 3, name: "FLOW_LANDER_ROLE_THANKYOU" },
]);

/**
 * @generated from enum tracker.v1.FlowMode
 */
export enum FlowMode {
  /**
   * @generated from enum value: FLOW_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FLOW_MODE_SINGLE_OFFER = 1;
   */
  SINGLE_OFFER = 1,

  /**
   * @generated from enum value: FLOW_MODE_SPLIT_TEST = 2;
   */
  SPLIT_TEST = 2,

  /**
   * @generated from enum value: FLOW_MODE_WEIGHTED_ROTATOR = 3;
   */
  WEIGHTED_ROTATOR = 3,

  /**
   * @generated from enum value: FLOW_MODE_RULE_BASED = 4;
   */
  RULE_BASED = 4,

  /**
   * @generated from enum value: FLOW_MODE_TEMPLATE_DERIVED = 5;
   */
  TEMPLATE_DERIVED = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(FlowMode)
proto3.util.setEnumType(FlowMode, "tracker.v1.FlowMode", [
  { no: 0, name: "FLOW_MODE_UNSPECIFIED" },
  { no: 1, name: "FLOW_MODE_SINGLE_OFFER" },
  { no: 2, name: "FLOW_MODE_SPLIT_TEST" },
  { no: 3, name: "FLOW_MODE_WEIGHTED_ROTATOR" },
  { no: 4, name: "FLOW_MODE_RULE_BASED" },
  { no: 5, name: "FLOW_MODE_TEMPLATE_DERIVED" },
]);

/**
 * @generated from enum tracker.v1.FlowNodeKind
 */
export enum FlowNodeKind {
  /**
   * @generated from enum value: FLOW_NODE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FLOW_NODE_KIND_FILTER = 1;
   */
  FILTER = 1,

  /**
   * @generated from enum value: FLOW_NODE_KIND_LANDER = 2;
   */
  LANDER = 2,

  /**
   * @generated from enum value: FLOW_NODE_KIND_OFFER = 3;
   */
  OFFER = 3,

  /**
   * @generated from enum value: FLOW_NODE_KIND_NETWORK = 4;
   */
  NETWORK = 4,

  /**
   * @generated from enum value: FLOW_NODE_KIND_REDIRECT = 5;
   */
  REDIRECT = 5,

  /**
   * @generated from enum value: FLOW_NODE_KIND_BOT_RULE = 8;
   */
  BOT_RULE = 8,

  /**
   * SAFE_PAGE — terminal node carrying a safe_page_url. Used by cloaker
   * funnels to send filtered traffic (bots / non-target geos) to a neutral
   * landing page distinct from money-side REDIRECTs.
   *
   * @generated from enum value: FLOW_NODE_KIND_SAFE_PAGE = 9;
   */
  SAFE_PAGE = 9,

  /**
   * JS_CHALLENGE — non-terminal interstitial. When the visitor has no valid
   * pass cookie, the router emits a JS+canvas+timing challenge page; on
   * success the page POSTs the proof to /jsc/verify which sets a signed
   * cookie and 302s back to /clk/{token} so the walk re-runs and falls
   * through the JS_CHALLENGE node to the configured next node (usually the
   * flow's default lander chain). Real browsers solve it transparently;
   * headless scrapers without canvas/timing fail closed.
   *
   * @generated from enum value: FLOW_NODE_KIND_JS_CHALLENGE = 10;
   */
  JS_CHALLENGE = 10,

  /**
   * FINGERPRINT_GATE — multi-signal cloaker scorer. Fuses TLS JA4 class,
   * headless-UA detection, and HTTP header anomaly score into a single
   * weighted [0,1] score, partitioned into three routing bands (low/medium
   * /high). High band is terminal (serves safe_page_url); low and medium
   * are transit so operators can chain JS_CHALLENGE or extra filters
   * downstream. See FingerprintGateConfig for weights + thresholds.
   *
   * @generated from enum value: FLOW_NODE_KIND_FINGERPRINT_GATE = 11;
   */
  FINGERPRINT_GATE = 11,

  /**
   * BRANCH — the root of a named monetisation branch (branch_trigger). Never on
   * the ad-click walk: the edge walks from it when the page runtime sends the
   * visitor in (?vt_br=<trigger>, signed). Transit — its edges pick the branch's
   * lander(s) / offers.
   *
   * @generated from enum value: FLOW_NODE_KIND_BRANCH = 12;
   */
  BRANCH = 12,
}
// Retrieve enum metadata with: proto3.getEnumType(FlowNodeKind)
proto3.util.setEnumType(FlowNodeKind, "tracker.v1.FlowNodeKind", [
  { no: 0, name: "FLOW_NODE_KIND_UNSPECIFIED" },
  { no: 1, name: "FLOW_NODE_KIND_FILTER" },
  { no: 2, name: "FLOW_NODE_KIND_LANDER" },
  { no: 3, name: "FLOW_NODE_KIND_OFFER" },
  { no: 4, name: "FLOW_NODE_KIND_NETWORK" },
  { no: 5, name: "FLOW_NODE_KIND_REDIRECT" },
  { no: 8, name: "FLOW_NODE_KIND_BOT_RULE" },
  { no: 9, name: "FLOW_NODE_KIND_SAFE_PAGE" },
  { no: 10, name: "FLOW_NODE_KIND_JS_CHALLENGE" },
  { no: 11, name: "FLOW_NODE_KIND_FINGERPRINT_GATE" },
  { no: 12, name: "FLOW_NODE_KIND_BRANCH" },
]);

/**
 * Flow is the routing graph attached to a Campaign. Nodes form a DAG; the
 * router walks them via explicit edges from default_node_id, applies filters,
 * and resolves to a (lander, offer, network) triple. A BRANCH node is a second
 * root: a named monetisation branch (Back, exit intent, idle, scroll end) the
 * page runtime sends a visitor into, walked from that node instead of
 * default_node_id.
 *
 * @generated from message tracker.v1.Flow
 */
export class Flow extends Message<Flow> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: tracker.v1.FlowMode mode = 4;
   */
  mode = FlowMode.UNSPECIFIED;

  /**
   * @generated from field: repeated tracker.v1.FlowNode nodes = 5;
   */
  nodes: FlowNode[] = [];

  /**
   * @generated from field: string default_node_id = 6;
   */
  defaultNodeId = "";

  /**
   * @generated from field: string fallback_offer_id = 7;
   */
  fallbackOfferId = "";

  /**
   * additional_context is the layered JSON merged into the click context
   * (campaign → flow → node). The map value is a JSON-encoded string so the
   * proto stays stable across schema changes.
   *
   * @generated from field: map<string, string> additional_context = 8;
   */
  additionalContext: { [key: string]: string } = {};

  /**
   * @generated from field: repeated tracker.v1.TagRef tags = 9;
   */
  tags: TagRef[] = [];

  /**
   * @generated from field: tracker.v1.Ownership ownership = 10;
   */
  ownership?: Ownership;

  /**
   * @generated from field: string created_at = 11;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 12;
   */
  updatedAt = "";

  /**
   * @generated from field: int32 version = 13;
   */
  version = 0;

  /**
   * edges describe explicit DAG connections between nodes. Required when
   * nodes>1: the router walks edges from default_node_id only — there is no
   * implicit linear sort_order fallback. Cycles and unreachable nodes are
   * rejected at the service layer (see ValidateFlow).
   *
   * @generated from field: repeated tracker.v1.FlowEdge edges = 14;
   */
  edges: FlowEdge[] = [];

  /**
   * Optional expr-lang expression evaluated post-merge against the flow's
   * additional_context bag. Lets authors derive computed keys without baking
   * logic into the click router. Empty disables the transform.
   *
   * @generated from field: string context_transform_expr = 15;
   */
  contextTransformExpr = "";

  /**
   * additional_context_schema declares the typed contract for keys in
   * additional_context. Map value is one of: string, number, integer, boolean,
   * string[], number[]. Empty map disables validation.
   *
   * @generated from field: map<string, string> additional_context_schema = 16;
   */
  additionalContextSchema: { [key: string]: string } = {};

  /**
   * @generated from field: string archived_at = 17;
   */
  archivedAt = "";

  /**
   * sticky_offer_ttl_seconds, when > 0, turns on sticky-offer rotation: the
   * first visit rolls a weighted OFFER node and the roll is pinned in a signed
   * cookie for this many seconds, so every later serve / CTA / back-button hit
   * resolves to the pinned offer across weight edits. 0 disables sticky pinning
   * (classic per-walk offer lookahead). This is the single authoring surface
   * that replaced CampaignFlowSpec.sticky_offer_ttl_seconds.
   *
   * @generated from field: uint32 sticky_offer_ttl_seconds = 18;
   */
  stickyOfferTtlSeconds = 0;

  /**
   * rotation_window_seconds, when > 0, enables guaranteed-different time
   * rotation of LANDER variants: within the window a returning visitor sees the
   * same lander (signed vt_rot_<camp> cookie); past the window the last-served
   * lander is excluded from the weighted candidate set and a fresh one is
   * rolled (is_rotation_reroll=1 on the step_view). 0 disables rotation.
   *
   * @generated from field: uint32 rotation_window_seconds = 19;
   */
  rotationWindowSeconds = 0;

  constructor(data?: PartialMessage<Flow>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.Flow";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "mode", kind: "enum", T: proto3.getEnumType(FlowMode) },
    { no: 5, name: "nodes", kind: "message", T: FlowNode, repeated: true },
    { no: 6, name: "default_node_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "fallback_offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "additional_context", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 9, name: "tags", kind: "message", T: TagRef, repeated: true },
    { no: 10, name: "ownership", kind: "message", T: Ownership },
    { no: 11, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "edges", kind: "message", T: FlowEdge, repeated: true },
    { no: 15, name: "context_transform_expr", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "additional_context_schema", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 17, name: "archived_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "sticky_offer_ttl_seconds", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 19, name: "rotation_window_seconds", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Flow {
    return new Flow().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Flow {
    return new Flow().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Flow {
    return new Flow().fromJsonString(jsonString, options);
  }

  static equals(a: Flow | PlainMessage<Flow> | undefined, b: Flow | PlainMessage<Flow> | undefined): boolean {
    return proto3.util.equals(Flow, a, b);
  }
}

/**
 * FlowEdge connects two nodes in a Flow DAG. condition_id optionally points
 * at a FILTER node whose evaluation gates traversal — this lets editors
 * model "Lander → if(US) → Offer A else Offer B" without abusing sort_order.
 *
 * @generated from message tracker.v1.FlowEdge
 */
export class FlowEdge extends Message<FlowEdge> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string source_id = 2;
   */
  sourceId = "";

  /**
   * @generated from field: string target_id = 3;
   */
  targetId = "";

  /**
   * Optional FILTER node id. When set, the edge is only followed if the
   * referenced node's expression evaluates true at click time.
   *
   * @generated from field: string condition_id = 4;
   */
  conditionId = "";

  /**
   * Sort order disambiguates outgoing edges when multiple are eligible —
   * the lowest sort_order matching node wins.
   *
   * @generated from field: int32 sort_order = 5;
   */
  sortOrder = 0;

  constructor(data?: PartialMessage<FlowEdge>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.FlowEdge";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "source_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "target_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "condition_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FlowEdge {
    return new FlowEdge().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FlowEdge {
    return new FlowEdge().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FlowEdge {
    return new FlowEdge().fromJsonString(jsonString, options);
  }

  static equals(a: FlowEdge | PlainMessage<FlowEdge> | undefined, b: FlowEdge | PlainMessage<FlowEdge> | undefined): boolean {
    return proto3.util.equals(FlowEdge, a, b);
  }
}

/**
 * @generated from message tracker.v1.FlowNode
 */
export class FlowNode extends Message<FlowNode> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: tracker.v1.FlowNodeKind kind = 2;
   */
  kind = FlowNodeKind.UNSPECIFIED;

  /**
   * @generated from field: int32 sort_order = 3;
   */
  sortOrder = 0;

  /**
   * 0..100 for rotators
   *
   * @generated from field: int32 weight = 4;
   */
  weight = 0;

  /**
   * @generated from field: bool enabled = 5;
   */
  enabled = false;

  /**
   * One-of payload — populated based on `kind`. Keeping it flat (rather than
   * proto oneof) makes JSON serialization predictable for the editor.
   *
   * for kind=FILTER and kind=BOT_RULE (legacy)
   *
   * @generated from field: tracker.v1.FlowFilter filter = 10;
   */
  filter?: FlowFilter;

  /**
   * for kind=LANDER
   *
   * @generated from field: string lander_id = 11;
   */
  landerId = "";

  /**
   * for kind=OFFER
   *
   * @generated from field: string offer_id = 12;
   */
  offerId = "";

  /**
   * for kind=NETWORK
   *
   * @generated from field: string network_id = 13;
   */
  networkId = "";

  /**
   * for kind=REDIRECT
   *
   * @generated from field: string redirect_url = 14;
   */
  redirectUrl = "";

  /**
   * @generated from field: map<string, string> additional_context = 17;
   */
  additionalContext: { [key: string]: string } = {};

  /**
   * for kind=SAFE_PAGE — terminal node that serves a compliance-safe URL.
   * Kept separate from redirect_url so cloaker analytics can distinguish
   * "served safe page" from a generic 302.
   *
   * @generated from field: string safe_page_url = 18;
   */
  safePageUrl = "";

  /**
   * for kind=JS_CHALLENGE — name of the signed pass cookie set after a
   * visitor solves the JS+canvas+timing challenge. Clients arriving with a
   * valid signed cookie skip the interstitial and the router transits to
   * the configured next node. Empty value is rejected at save time.
   *
   * @generated from field: string challenge_cookie_name = 19;
   */
  challengeCookieName = "";

  /**
   * for kind=JS_CHALLENGE — pass-cookie TTL in seconds. Zero means
   * "use the JS_CHALLENGE_DEFAULT_TTL_SECONDS server default" (1800s /
   * 30 minutes). Negative is rejected at save time.
   *
   * @generated from field: int32 challenge_ttl_seconds = 20;
   */
  challengeTtlSeconds = 0;

  /**
   * for kind=FINGERPRINT_GATE — per-node weighting and thresholds for the
   * multi-signal cloaker gate. When kind != FINGERPRINT_GATE this field is
   * unset and must be ignored.
   *
   * @generated from field: tracker.v1.FingerprintGateConfig fingerprint_gate = 21;
   */
  fingerprintGate?: FingerprintGateConfig;

  /**
   * node carries EITHER an inline typed condition OR a reference to a library
   * rule (rule_id + rule_version). The server resolves a reference into
   * `condition` on read so the router always sees a fully-resolved tree.
   *
   * for kind=FILTER and kind=BOT_RULE (inline or resolved)
   *
   * @generated from field: tracker.v1.Condition condition = 22;
   */
  condition?: Condition;

  /**
   * Library rule reference (CLICK rule). When set, `condition` is the resolved
   * snapshot of rule_id @ rule_version; edits flow through the referenced rule.
   *
   * @generated from field: string rule_id = 23;
   */
  ruleId = "";

  /**
   * @generated from field: int32 rule_version = 24;
   */
  ruleVersion = 0;

  /**
   * for kind=LANDER — funnel-position label (prelander | landing | thankyou).
   * Descriptive only; the router does not branch on it. Unspecified == LANDING.
   * Ignored for non-LANDER kinds.
   *
   * @generated from field: tracker.v1.FlowLanderRole lander_role = 25;
   */
  landerRole = FlowLanderRole.UNSPECIFIED;

  /**
   * for kind=BRANCH — what enters this branch (ADR 0002, phase 4). A BRANCH
   * node has no incoming edges; its outgoing edges lead to the branch's own
   * lander(s) and/or offers. One per trigger per flow.
   *
   * @generated from field: tracker.v1.BranchTrigger branch_trigger = 27;
   */
  branchTrigger = BranchTrigger.UNSPECIFIED;

  /**
   * for kind=BRANCH with trigger IDLE — seconds without input (5..600; the page runtime counts on its 15-minute page clock).
   *
   * @generated from field: uint32 branch_idle_seconds = 28;
   */
  branchIdleSeconds = 0;

  constructor(data?: PartialMessage<FlowNode>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.FlowNode";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "kind", kind: "enum", T: proto3.getEnumType(FlowNodeKind) },
    { no: 3, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "weight", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "filter", kind: "message", T: FlowFilter },
    { no: 11, name: "lander_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "network_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "additional_context", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 18, name: "safe_page_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "challenge_cookie_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "challenge_ttl_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 21, name: "fingerprint_gate", kind: "message", T: FingerprintGateConfig },
    { no: 22, name: "condition", kind: "message", T: Condition },
    { no: 23, name: "rule_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "rule_version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 25, name: "lander_role", kind: "enum", T: proto3.getEnumType(FlowLanderRole) },
    { no: 27, name: "branch_trigger", kind: "enum", T: proto3.getEnumType(BranchTrigger) },
    { no: 28, name: "branch_idle_seconds", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FlowNode {
    return new FlowNode().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FlowNode {
    return new FlowNode().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FlowNode {
    return new FlowNode().fromJsonString(jsonString, options);
  }

  static equals(a: FlowNode | PlainMessage<FlowNode> | undefined, b: FlowNode | PlainMessage<FlowNode> | undefined): boolean {
    return proto3.util.equals(FlowNode, a, b);
  }
}

/**
 * FingerprintGateConfig parameterises a FlowNodeKindFingerprintGate node.
 * Weights are independent magnitudes (not a probability distribution) — the
 * click-time evaluator normalises them so any non-negative tuple yields a
 * score in [0,1]. low_threshold and high_threshold partition that score into
 * the three routing bands (low/medium/high). All-zero weights default to
 * equal thirds; zero thresholds default to 0.33 / 0.66. Save-time validation
 * guarantees 0 ≤ low_threshold ≤ high_threshold ≤ 1 and all weights ≥ 0.
 *
 * @generated from message tracker.v1.FingerprintGateConfig
 */
export class FingerprintGateConfig extends Message<FingerprintGateConfig> {
  /**
   * Weight applied to the TLS JA4 classification signal. Contributes when
   * ctx.Bot.JA4Class == "bot".
   *
   * @generated from field: double ja4_weight = 1;
   */
  ja4Weight = 0;

  /**
   * Weight applied to the headless-UA detection signal. Contributes when
   * ctx.Bot.UAAnomaly is true (headless / scripted UA signature).
   *
   * @generated from field: double ua_weight = 2;
   */
  uaWeight = 0;

  /**
   * Weight applied to the HTTP header anomaly score [0,1] computed by the
   * CF Worker and forwarded via X-Header-Anomaly-Score.
   *
   * @generated from field: double header_weight = 3;
   */
  headerWeight = 0;

  /**
   * Score band lower bound. Below this value the click is treated as clean
   * (low band — walker transits).
   *
   * @generated from field: double low_threshold = 4;
   */
  lowThreshold = 0;

  /**
   * Score band upper bound. At or above this value the click is treated as
   * high-confidence bot (high band — terminal exit via safe_page_url).
   *
   * @generated from field: double high_threshold = 5;
   */
  highThreshold = 0;

  constructor(data?: PartialMessage<FingerprintGateConfig>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.FingerprintGateConfig";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ja4_weight", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "ua_weight", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "header_weight", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "low_threshold", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "high_threshold", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FingerprintGateConfig {
    return new FingerprintGateConfig().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FingerprintGateConfig {
    return new FingerprintGateConfig().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FingerprintGateConfig {
    return new FingerprintGateConfig().fromJsonString(jsonString, options);
  }

  static equals(a: FingerprintGateConfig | PlainMessage<FingerprintGateConfig> | undefined, b: FingerprintGateConfig | PlainMessage<FingerprintGateConfig> | undefined): boolean {
    return proto3.util.equals(FingerprintGateConfig, a, b);
  }
}

/**
 * FlowFilter is the canonical filter expression. It is a tree: groups branch,
 * leaves match request-time facts. Both the click-time router
 * (internal/router) and the CF Worker (vibe-infra/workers/edge-router)
 * evaluate this tree — invariant: same input yields same boolean.
 *
 * Per-kind payload slots are flat on the message so the wire shape stays
 * stable across schema growth; only the slots relevant to `kind` are read.
 *
 * @generated from message tracker.v1.FlowFilter
 */
export class FlowFilter extends Message<FlowFilter> {
  /**
   * @generated from field: string kind = 1;
   */
  kind = "";

  /**
   * @generated from field: repeated tracker.v1.FlowFilter children = 2;
   */
  children: FlowFilter[] = [];

  /**
   * country, language
   *
   * @generated from field: repeated string codes = 3;
   */
  codes: string[] = [];

  /**
   * device — values: mobile/tablet/desktop
   *
   * @generated from field: repeated string devices = 4;
   */
  devices: string[] = [];

  /**
   * ua_regex, referrer
   *
   * @generated from field: string pattern = 5;
   */
  pattern = "";

  /**
   * url_param, header
   *
   * @generated from field: string name = 6;
   */
  name = "";

  /**
   * url_param, header
   *
   * @generated from field: string value = 7;
   */
  value = "";

  /**
   * ip_cidr
   *
   * @generated from field: repeated string cidrs = 8;
   */
  cidrs: string[] = [];

  /**
   * bot_score
   *
   * @generated from field: int32 threshold = 9;
   */
  threshold = 0;

  /**
   * bot_score: eq/lt/lte/gt/gte
   *
   * @generated from field: string op = 10;
   */
  op = "";

  /**
   * time_of_day (UTC, 0-24)
   *
   * @generated from field: int32 hour_start = 11;
   */
  hourStart = 0;

  /**
   * time_of_day
   *
   * @generated from field: int32 hour_end = 12;
   */
  hourEnd = 0;

  /**
   * weight_split (0-100)
   *
   * @generated from field: int32 weight = 13;
   */
  weight = 0;

  /**
   * expression — expr-lang src
   *
   * @generated from field: string expression = 14;
   */
  expression = "";

  constructor(data?: PartialMessage<FlowFilter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.FlowFilter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "children", kind: "message", T: FlowFilter, repeated: true },
    { no: 3, name: "codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "devices", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "pattern", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "cidrs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "threshold", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "op", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "hour_start", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "hour_end", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "weight", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "expression", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FlowFilter {
    return new FlowFilter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FlowFilter {
    return new FlowFilter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FlowFilter {
    return new FlowFilter().fromJsonString(jsonString, options);
  }

  static equals(a: FlowFilter | PlainMessage<FlowFilter> | undefined, b: FlowFilter | PlainMessage<FlowFilter> | undefined): boolean {
    return proto3.util.equals(FlowFilter, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListFlowsRequest
 */
export class ListFlowsRequest extends Message<ListFlowsRequest> {
  /**
   * @generated from field: tracker.v1.Pagination pagination = 1;
   */
  pagination?: Pagination;

  /**
   * @generated from field: string search = 2;
   */
  search = "";

  /**
   * Flows by their own id.
   *
   * @generated from field: repeated string ids = 3;
   */
  ids: string[] = [];

  /**
   * name | updated_at | created_at (default: created_at, newest first).
   *
   * @generated from field: tracker.v1.ListSort sort = 4;
   */
  sort?: ListSort;

  constructor(data?: PartialMessage<ListFlowsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListFlowsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: Pagination },
    { no: 2, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "sort", kind: "message", T: ListSort },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFlowsRequest {
    return new ListFlowsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFlowsRequest {
    return new ListFlowsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFlowsRequest {
    return new ListFlowsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListFlowsRequest | PlainMessage<ListFlowsRequest> | undefined, b: ListFlowsRequest | PlainMessage<ListFlowsRequest> | undefined): boolean {
    return proto3.util.equals(ListFlowsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListFlowsResponse
 */
export class ListFlowsResponse extends Message<ListFlowsResponse> {
  /**
   * @generated from field: repeated tracker.v1.Flow items = 1;
   */
  items: Flow[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  constructor(data?: PartialMessage<ListFlowsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListFlowsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: Flow, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFlowsResponse {
    return new ListFlowsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFlowsResponse {
    return new ListFlowsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFlowsResponse {
    return new ListFlowsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListFlowsResponse | PlainMessage<ListFlowsResponse> | undefined, b: ListFlowsResponse | PlainMessage<ListFlowsResponse> | undefined): boolean {
    return proto3.util.equals(ListFlowsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetFlowRequest
 */
export class GetFlowRequest extends Message<GetFlowRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetFlowRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetFlowRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFlowRequest {
    return new GetFlowRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFlowRequest {
    return new GetFlowRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFlowRequest {
    return new GetFlowRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFlowRequest | PlainMessage<GetFlowRequest> | undefined, b: GetFlowRequest | PlainMessage<GetFlowRequest> | undefined): boolean {
    return proto3.util.equals(GetFlowRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetFlowResponse
 */
export class GetFlowResponse extends Message<GetFlowResponse> {
  /**
   * @generated from field: tracker.v1.Flow flow = 1;
   */
  flow?: Flow;

  constructor(data?: PartialMessage<GetFlowResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetFlowResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "flow", kind: "message", T: Flow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFlowResponse {
    return new GetFlowResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFlowResponse {
    return new GetFlowResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFlowResponse {
    return new GetFlowResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFlowResponse | PlainMessage<GetFlowResponse> | undefined, b: GetFlowResponse | PlainMessage<GetFlowResponse> | undefined): boolean {
    return proto3.util.equals(GetFlowResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateFlowRequest
 */
export class CreateFlowRequest extends Message<CreateFlowRequest> {
  /**
   * @generated from field: tracker.v1.Flow flow = 1;
   */
  flow?: Flow;

  constructor(data?: PartialMessage<CreateFlowRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateFlowRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "flow", kind: "message", T: Flow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateFlowRequest {
    return new CreateFlowRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateFlowRequest {
    return new CreateFlowRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateFlowRequest {
    return new CreateFlowRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateFlowRequest | PlainMessage<CreateFlowRequest> | undefined, b: CreateFlowRequest | PlainMessage<CreateFlowRequest> | undefined): boolean {
    return proto3.util.equals(CreateFlowRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateFlowResponse
 */
export class CreateFlowResponse extends Message<CreateFlowResponse> {
  /**
   * @generated from field: tracker.v1.Flow flow = 1;
   */
  flow?: Flow;

  constructor(data?: PartialMessage<CreateFlowResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateFlowResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "flow", kind: "message", T: Flow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateFlowResponse {
    return new CreateFlowResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateFlowResponse {
    return new CreateFlowResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateFlowResponse {
    return new CreateFlowResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateFlowResponse | PlainMessage<CreateFlowResponse> | undefined, b: CreateFlowResponse | PlainMessage<CreateFlowResponse> | undefined): boolean {
    return proto3.util.equals(CreateFlowResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateFlowRequest
 */
export class UpdateFlowRequest extends Message<UpdateFlowRequest> {
  /**
   * @generated from field: tracker.v1.Flow flow = 1;
   */
  flow?: Flow;

  constructor(data?: PartialMessage<UpdateFlowRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateFlowRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "flow", kind: "message", T: Flow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateFlowRequest {
    return new UpdateFlowRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateFlowRequest {
    return new UpdateFlowRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateFlowRequest {
    return new UpdateFlowRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateFlowRequest | PlainMessage<UpdateFlowRequest> | undefined, b: UpdateFlowRequest | PlainMessage<UpdateFlowRequest> | undefined): boolean {
    return proto3.util.equals(UpdateFlowRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateFlowResponse
 */
export class UpdateFlowResponse extends Message<UpdateFlowResponse> {
  /**
   * @generated from field: tracker.v1.Flow flow = 1;
   */
  flow?: Flow;

  constructor(data?: PartialMessage<UpdateFlowResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateFlowResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "flow", kind: "message", T: Flow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateFlowResponse {
    return new UpdateFlowResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateFlowResponse {
    return new UpdateFlowResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateFlowResponse {
    return new UpdateFlowResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateFlowResponse | PlainMessage<UpdateFlowResponse> | undefined, b: UpdateFlowResponse | PlainMessage<UpdateFlowResponse> | undefined): boolean {
    return proto3.util.equals(UpdateFlowResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ArchiveFlowRequest
 */
export class ArchiveFlowRequest extends Message<ArchiveFlowRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<ArchiveFlowRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ArchiveFlowRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveFlowRequest {
    return new ArchiveFlowRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveFlowRequest {
    return new ArchiveFlowRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveFlowRequest {
    return new ArchiveFlowRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveFlowRequest | PlainMessage<ArchiveFlowRequest> | undefined, b: ArchiveFlowRequest | PlainMessage<ArchiveFlowRequest> | undefined): boolean {
    return proto3.util.equals(ArchiveFlowRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ArchiveFlowResponse
 */
export class ArchiveFlowResponse extends Message<ArchiveFlowResponse> {
  constructor(data?: PartialMessage<ArchiveFlowResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ArchiveFlowResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveFlowResponse {
    return new ArchiveFlowResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveFlowResponse {
    return new ArchiveFlowResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveFlowResponse {
    return new ArchiveFlowResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveFlowResponse | PlainMessage<ArchiveFlowResponse> | undefined, b: ArchiveFlowResponse | PlainMessage<ArchiveFlowResponse> | undefined): boolean {
    return proto3.util.equals(ArchiveFlowResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ValidateFlowRequest
 */
export class ValidateFlowRequest extends Message<ValidateFlowRequest> {
  /**
   * @generated from field: tracker.v1.Flow flow = 1;
   */
  flow?: Flow;

  constructor(data?: PartialMessage<ValidateFlowRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ValidateFlowRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "flow", kind: "message", T: Flow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateFlowRequest {
    return new ValidateFlowRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateFlowRequest {
    return new ValidateFlowRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateFlowRequest {
    return new ValidateFlowRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateFlowRequest | PlainMessage<ValidateFlowRequest> | undefined, b: ValidateFlowRequest | PlainMessage<ValidateFlowRequest> | undefined): boolean {
    return proto3.util.equals(ValidateFlowRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ValidateFlowResponse
 */
export class ValidateFlowResponse extends Message<ValidateFlowResponse> {
  /**
   * @generated from field: repeated tracker.v1.FieldError errors = 1;
   */
  errors: FieldError[] = [];

  constructor(data?: PartialMessage<ValidateFlowResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ValidateFlowResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "errors", kind: "message", T: FieldError, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateFlowResponse {
    return new ValidateFlowResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateFlowResponse {
    return new ValidateFlowResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateFlowResponse {
    return new ValidateFlowResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateFlowResponse | PlainMessage<ValidateFlowResponse> | undefined, b: ValidateFlowResponse | PlainMessage<ValidateFlowResponse> | undefined): boolean {
    return proto3.util.equals(ValidateFlowResponse, a, b);
  }
}

/**
 * SuggestFlow drafts a complete flow graph from a plain-English funnel
 * description via the workspace's OpenRouter connection. The server validates
 * (and once repairs) the draft through the same suite ValidateFlow runs;
 * residual issues come back in `errors` so the editor can show "draft has N
 * issues" instead of failing.
 *
 * @generated from message tracker.v1.SuggestFlowRequest
 */
export class SuggestFlowRequest extends Message<SuggestFlowRequest> {
  /**
   * @generated from field: string description = 1;
   */
  description = "";

  constructor(data?: PartialMessage<SuggestFlowRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SuggestFlowRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SuggestFlowRequest {
    return new SuggestFlowRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SuggestFlowRequest {
    return new SuggestFlowRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SuggestFlowRequest {
    return new SuggestFlowRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SuggestFlowRequest | PlainMessage<SuggestFlowRequest> | undefined, b: SuggestFlowRequest | PlainMessage<SuggestFlowRequest> | undefined): boolean {
    return proto3.util.equals(SuggestFlowRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.SuggestFlowResponse
 */
export class SuggestFlowResponse extends Message<SuggestFlowResponse> {
  /**
   * @generated from field: tracker.v1.Flow flow = 1;
   */
  flow?: Flow;

  /**
   * @generated from field: string rationale = 2;
   */
  rationale = "";

  /**
   * @generated from field: repeated tracker.v1.FieldError errors = 3;
   */
  errors: FieldError[] = [];

  constructor(data?: PartialMessage<SuggestFlowResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SuggestFlowResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "flow", kind: "message", T: Flow },
    { no: 2, name: "rationale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "errors", kind: "message", T: FieldError, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SuggestFlowResponse {
    return new SuggestFlowResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SuggestFlowResponse {
    return new SuggestFlowResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SuggestFlowResponse {
    return new SuggestFlowResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SuggestFlowResponse | PlainMessage<SuggestFlowResponse> | undefined, b: SuggestFlowResponse | PlainMessage<SuggestFlowResponse> | undefined): boolean {
    return proto3.util.equals(SuggestFlowResponse, a, b);
  }
}

/**
 * QuickStartFlow stamps a simple, immediately-editable starter graph:
 *
 *   [prelander?] --> landing --> offer
 *
 * The result is a NORMAL editable flow (mode SINGLE_OFFER) the author then
 * shapes freely — it replaces the retired campaign-managed template
 * generation. lander_id + offer_id are required; prelander_id is optional.
 *
 * @generated from message tracker.v1.QuickStartFlowRequest
 */
export class QuickStartFlowRequest extends Message<QuickStartFlowRequest> {
  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string lander_id = 3;
   */
  landerId = "";

  /**
   * @generated from field: string offer_id = 4;
   */
  offerId = "";

  /**
   * Optional prelander served ahead of the landing (entry node when set).
   *
   * @generated from field: string prelander_id = 5;
   */
  prelanderId = "";

  constructor(data?: PartialMessage<QuickStartFlowRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.QuickStartFlowRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lander_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "prelander_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuickStartFlowRequest {
    return new QuickStartFlowRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuickStartFlowRequest {
    return new QuickStartFlowRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuickStartFlowRequest {
    return new QuickStartFlowRequest().fromJsonString(jsonString, options);
  }

  static equals(a: QuickStartFlowRequest | PlainMessage<QuickStartFlowRequest> | undefined, b: QuickStartFlowRequest | PlainMessage<QuickStartFlowRequest> | undefined): boolean {
    return proto3.util.equals(QuickStartFlowRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.QuickStartFlowResponse
 */
export class QuickStartFlowResponse extends Message<QuickStartFlowResponse> {
  /**
   * @generated from field: tracker.v1.Flow flow = 1;
   */
  flow?: Flow;

  constructor(data?: PartialMessage<QuickStartFlowResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.QuickStartFlowResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "flow", kind: "message", T: Flow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QuickStartFlowResponse {
    return new QuickStartFlowResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QuickStartFlowResponse {
    return new QuickStartFlowResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QuickStartFlowResponse {
    return new QuickStartFlowResponse().fromJsonString(jsonString, options);
  }

  static equals(a: QuickStartFlowResponse | PlainMessage<QuickStartFlowResponse> | undefined, b: QuickStartFlowResponse | PlainMessage<QuickStartFlowResponse> | undefined): boolean {
    return proto3.util.equals(QuickStartFlowResponse, a, b);
  }
}

